// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Vp34z","title":"classes_title__l6pGT"};